import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useNotification } from 'src/contexts/notification.context'
import { createPrintable, getPrintableThemes } from 'src/services/api.service'
import { BackLink } from 'src/components/common'
import { routes } from 'src/navigation/routes'
import { PRINT_STATUS_ENUM } from 'src/tools'
import PrintableForm from './form'

const initialValues = {
  ages: [],
  grades: [],
  title: '',
  subject_id: null,
  description: '',
  sort: 400,
  active: 0,
  price: '0.00',
  file_description: '',
  pages_count: 1,
  themes: [],
  topics: [],
  file: [],
  images: [],
  status: 'draft',
  practice_url: '',
}

export const ShopNew = () => {
  const history = useHistory()
  const { wrapCallback } = useNotification()

  const onSubmit = async (values, status) => {
    wrapCallback(async () => {
      await createPrintable(values)

      history.replace(routes.printables.index, {
        step: status === PRINT_STATUS_ENUM.in_review ? 4 : undefined,
      })
    })
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes.printables.index} />
        <h2 className="sectionHb-title">Add printable worksheets</h2>
      </div>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <PrintableForm initialValues={initialValues} onSubmit={onSubmit} />
        </div>
      </div>
    </>
  )
}
